import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { PerformanceSection } from '@/features/reports/performance'

/** Officer, branch and group performance, as an addressable screen of its own. */
export function ReportsPerformancePage() {
  return (
    <>
      <Link
        to="/reports"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All reports
      </Link>

      <PageHeader
        title="Officer, branch & group performance"
        description="Portfolio quality as at a date and collection activity over a period, sliced by whichever dimension is asked for."
      />

      <PerformanceSection />
    </>
  )
}
